<template>
    <div class="hm">
        <div class="hm-container">
            <div class="hm-menu">
                <div
                    class="hm-menu__item"
                    @click="$router.push({ name: 'prep' })"
                >
                    PREP
                    <span>Consejo</span>
                </div>
                <div
                    class="hm-menu__item"
                    @click="$router.push({ name: 'auditoria' })"
                >
                    Auditoría
                    <span>Consejo</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    methods: {
        logout() {
            console.log('logout');
            this.$store.commit('SET_TOKEN', null);
            this.$router.push({ name: 'Login' });
        },
    },
};
</script>

<style lang="scss">
.hm {
    display: flex;
    flex-direction: column;
    min-height: 100%;

    &-header {
        display: flex;
        padding: 10px;
        justify-content: flex-end;

        .hm-header__logout {
            background-color: lightgray;
            padding: 10px;
            border-radius: 5px;
            font-weight: bolder;
        }
    }
}

.hm-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    font-size: 2.5rem;
}

.hm-menu {
    display: flex;
    flex-direction: column;
}

.hm-menu__item {
    display: flex;
    flex-direction: column;
    margin: 2rem;
    cursor: pointer;

    & > span {
        color: dimgray;
        font-size: 1rem;
    }
}
</style>
